(function () {
    'use strict';

    angular.module("imApp").factory("eCommerceStatusService", ['$ihttp', function ($ihttp) {
        let service = {
            startSync: function (edit) {
                return $ihttp.post({
                    method: 724,
                    parameters: edit || {}
                });
            }
        };

        return service;
    }]);
})();
